module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_top_promo_numbers-81027a61ade6490ba893d78f249b6b8c.png";